class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).on(
        "click",
        function (e) {
          e.preventDefault();
          var $this = $(this);
          if (!$this.hasClass("accordion-active")) {
            $(".faq-inner-content").slideUp(350);
            $(".faq-inner-title").removeClass("accordion-active");
            $(".accordion__arrow").removeClass("accordion__rotate");
          }

          $this.toggleClass("accordion-active");
          $this.next().slideToggle();
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);

// Key Ingredient Section
class KeyIngredients extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      // =========Accordion=========
      $(".accordion-" + this.getAttribute("data-sectionid")).on(
        "click",
        function (e) {
          e.preventDefault();
          var $this = $(this);
          if (!$this.hasClass("accordion-active")) {
            $(".accordion_content").slideUp(350);
            $(".accordion_headbox").removeClass("accordion-active");
          }

          $this.toggleClass("accordion-active");
          $this.next().slideToggle();
        }
      );
      // =========Accordion End=========

      // =========View More=========
      // var sectionId = this.getAttribute("data-sectionid");
      // function isSmallScreen() {
      //   return window.innerWidth <= 990;
      // }

      // const accordionItems = document.querySelectorAll(".indedient_accordion-" + sectionId);
      // const seeAllBtn = document.getElementById("see_allbtn-" + sectionId);
      // const viewMoreBtn = document.getElementById("view_more_btn-" + sectionId );
      // const itemsPerClick = 4;
      // let currentIndex = itemsPerClick;

      // function initializeAccordion() {
      //   if (!isSmallScreen()) return;
      //   for (let i = 0; i < accordionItems.length; i++) {
      //     if (i >= itemsPerClick) {
      //       accordionItems[i].classList.add("hidden_accordion");
      //     }
      //   }
      //   if (accordionItems.length <= 4) {
      //     viewMoreBtn.style.display = "none";
      //     seeAllBtn.style.display = "flex";
      //   } else {
      //     viewMoreBtn.style.display = "flex";
      //   }
      // }

      // viewMoreBtn.addEventListener("click", () => {
      //   if (!isSmallScreen()) return;
      //   let endIndex = currentIndex + itemsPerClick;
      //   for (let i = currentIndex; i < endIndex; i++) {
      //     if (accordionItems[i]) {
      //       accordionItems[i].classList.remove("hidden_accordion");
      //     }
      //   }
      //   currentIndex = endIndex;
      //   if (currentIndex >= accordionItems.length) {
      //     viewMoreBtn.style.display = "none";
      //     seeAllBtn.style.display = "flex";
      //   }
      // });
      // initializeAccordion();

      // =========See All=========
var sectionId = this.getAttribute("data-sectionid");
const accordionItems = document.querySelectorAll(".indedient_accordion-" + sectionId);
const seeAllBtns = document.querySelectorAll(".see_allbtn-" + sectionId); // <-- selects both buttons
const itemsToShow = 4;

function initializeAccordion() {
  // Hide everything after the first 4
  accordionItems.forEach((item, i) => {
    if (i >= itemsToShow) {
      item.classList.add("hidden_accordion");
    } else {
      item.classList.remove("hidden_accordion");
    }
  });

  // Show See All buttons only if more than 4 items
  if (accordionItems.length > itemsToShow) {
    seeAllBtns.forEach(btn => btn.style.display = "flex");
  } else {
    seeAllBtns.forEach(btn => btn.style.display = "none");
  }
}

// Reveal all hidden items on any See All click
seeAllBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    accordionItems.forEach(item => item.classList.remove("hidden_accordion"));
    seeAllBtns.forEach(b => b.style.display = "none"); // hide both buttons
  });
});

initializeAccordion();


      // =========View More End=========
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("key-ingredients", KeyIngredients);
// Rethinking Section
class rethinKing extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var sectionId = this.getAttribute("data-sectionid");
      console.log(sectionId + "---------------------------------ID");

      $(".countup-" + sectionId).each(function () {
        var $this = $(this);
        var countTo = parseInt($this.text());

        
        var unit = $this.data("unit") || ""; 

        $this.text("0" + unit);

        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 3000,
            easing: "swing",
            step: function () {
              $this.text(Math.floor(this.countNum) + unit);
            },
            complete: function () {
              $this.text(countTo + unit);
            },
          }
        );
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("rethinking-section", rethinKing);


class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      var galleryThumbs = new Swiper(".thumb-slider", {
        spaceBetween: 5,
        direction: "horizontal",
        slidesPerView: 6,
        breakpoints: {
          0: {
            slidesPerView: 5,
            spaceBetween: 10,
            direction: "horizontal",
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 16,
            direction: "vertical",
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 20,
            direction: "vertical",
          },
          1441: {
            slidesPerView: 6,
            spaceBetween: 20,
            direction: "vertical",
          },
        },
      });

      var galleryTop = new Swiper(".main-slider", {
        spaceBetween: 15,
        direction: "horizontal",
        thumbs: {
          swiper: galleryThumbs,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },
        },
      });

      document.addEventListener("repositionmainslider", (e) => {
        var index = e.detail.index;
        galleryTop.slideTo(index);
        galleryThumbs.slideTo(index);
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-slider", CustomSlider);



// Compare Table 
 class compareTableSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const sectionId = this.getAttribute("data-sectionid");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        const tableRows = document.querySelectorAll(".table-row-" + sectionId );
        const seeMoreBtn = document.getElementById("show-more-rows-" + sectionId);
        const isMobile = () => window.innerWidth <= 768;

        const mobileThreshold = 8;
        const desktopThreshold = 8;
        const threshold = isMobile() ? mobileThreshold : desktopThreshold;
        const rowsPerClick = threshold;
        let currentIndex = threshold;

        const initializeRows = () => {
          // Initially hide rows beyond threshold
          tableRows.forEach((row, index) => {
            if (index >= threshold) {
              row.classList.add("hidden_rows");
            }
          });

          // Show or hide "See More" button
          if (tableRows.length <= threshold) {
            seeMoreBtn.style.display = "none";
          } else {
            seeMoreBtn.style.display = "flex";
          }
        };

        const revealNextRows = () => {
          const endIndex = currentIndex + rowsPerClick;
          for (let i = currentIndex; i < endIndex; i++) {
            if (tableRows[i]) {
              tableRows[i].classList.remove("hidden_rows");
            }
          }
          currentIndex = endIndex;

          if (currentIndex >= tableRows.length) {
            seeMoreBtn.style.display = "none";
          }
        };

        seeMoreBtn?.addEventListener("click", revealNextRows);
        initializeRows();
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }     

  customElements.define("compare-table-section", compareTableSection);
                                 